export const Service_Action_Types = {
    FETCH_SERVICES_START: "service/FETCH_SERVICES_START",
    FETCH_SERVICES_SUCCESS: "service/FETCH_SERVICES_SUCCESS",
    FETCH_SERVICES_FAILED: "service/FETCH_SERVICES_FAILED",
    FETCH_SERVICES_OPTION_LIST: "service/FETCH_SERVICES_OPTION_LIST",
    SET_PAGE_SIZE: "service/SET_PAGE_SIZE",
    SET_IS_UPDATED: "service/SET_IS_UPDATED",
    SET_FILTER_SEARCH_STRING: "service/SET_FILTER_SEARCH_STRING"
}